export const LOADING_CATEGORY = 'LOADING_CATEGORY';
export const GET_CATEGORY = 'GET_CATEGORY';
export const FILTER_CATEGORY = 'FILTER_CATEGORY';
export const GET_CATEGORY_DETAILS = 'GET_CATEGORY_DETAILS';
export const IS_ADD_CATEGORY = 'IS_ADD_CATEGORY';
export const IS_CHANGED_CATEGORY = 'IS_CHANGED_CATEGORY';